// USD per 1M tokens. Update when providers change pricing.
// Sources: provider pricing pages as of 2026-05.
const TABLE: Record<string, { input: number; output: number }> = {
  // Google Gemini
  'gemini-2.5-pro':       { input: 1.25, output: 10.00 },
  'gemini-2.5-flash':     { input: 0.30, output: 2.50 },
  'gemini-2.0-flash':     { input: 0.10, output: 0.40 },
  // OpenAI
  'gpt-4o':               { input: 2.50, output: 10.00 },
  'gpt-4o-mini':          { input: 0.15, output: 0.60 },
  'gpt-4-turbo':          { input: 10.00, output: 30.00 },
  // Anthropic Claude
  'claude-opus-4':        { input: 15.00, output: 75.00 },
  'claude-sonnet-4':      { input: 3.00, output: 15.00 },
  'claude-haiku-4':       { input: 0.80, output: 4.00 },
};

export function computeCost(
  model: string,
  inputTokens: number,
  outputTokens: number,
): number | null {
  const p = TABLE[model];
  if (!p) return null;
  return (inputTokens * p.input + outputTokens * p.output) / 1_000_000;
}

export function knownModels(): string[] {
  return Object.keys(TABLE);
}
